import { Plan } from "../dataTypes";

export const initialValues: Plan = {
  title: "",
  description: "",
  saasProducts: [],
  trialPeriod: {
    active: false,
    days: 0,
  },
  credits: {
    active: false,
    creditType: "recurring",
    amount: 0,
  },
  userLimit: 0, // 0 means unlimited
  contactLimit: 0, // 0 means unlimited
  prices: [
    {
      id: "price_month_" + Date.now(),
      billingInterval: "month",
      active: true,
      amount: 0,
      currency: "USD",
      symbol: "$",
    },
    {
      id: "price_year_" + Date.now(),
      billingInterval: "year",
      active: true,
      amount: 0,
      currency: "USD",
      symbol: "$",
    },
  ],
  rebilling: [],
};

export const mockPlanData: Plan = {
  _id: "plan-123",
  companyId: "company-123",
  title: "Professional Plan",
  description: "Advanced features for growing businesses",
  saasProducts: ["CRM System", "Analytics Dashboard", "Customer Support"],
  trialPeriod: {
    active: true,
    days: 14,
  },
  credits: {
    active: true,
    creditType: "recurring",
    amount: 1000,
  },
  userLimit: 10,
  contactLimit: 5000,
  prices: [
    {
      id: "price_month_123",
      billingInterval: "month",
      active: true,
      amount: 99,
      currency: "USD",
      symbol: "$",
    },
    {
      id: "price_year_123",
      billingInterval: "year",
      active: true,
      amount: 999,
      currency: "USD",
      symbol: "$",
    },
  ],
  rebilling: [
    {
      interval: "month",
      amount: 99,
      active: true,
    },
  ],
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
};

export const defaultSaasProducts = [
  "CRM System",
  "Email Marketing",
  "Analytics Dashboard",
  "Customer Support",
  "API Access",
  "Mobile App",
  "Reporting Tools",
  "Automation Workflows"
];